import React, { useState } from 'react';
import { LayoutDashboard, Package, Truck, History, Settings, Bell, Search, User, LogOut, Store } from 'lucide-react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface POSLayoutProps {
  children: React.ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
}
export function POSLayout({
  children,
  activeTab,
  onTabChange
}: POSLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navItems = [{
    id: 'dashboard',
    label: 'Order Queue',
    icon: LayoutDashboard
  }, {
    id: 'history',
    label: 'Order History',
    icon: History
  }];
  return <div className="flex h-screen bg-[#F1F5F9] font-sans text-slate-900 overflow-hidden" data-id="element-626">
      {/* Sidebar */}
      <aside className={cn('bg-[#0F172A] text-white flex flex-col transition-all duration-300', isSidebarOpen ? 'w-64' : 'w-20')} data-id="element-627">
        <div className="p-6 flex items-center gap-3 border-b border-slate-800" data-id="element-628">
          <div className="bg-blue-600 p-2 rounded-lg" data-id="element-629">
            <Store className="w-6 h-6" data-id="element-630" />
          </div>
          {isSidebarOpen && <div className="overflow-hidden whitespace-nowrap" data-id="element-631">
              <h1 className="font-bold text-lg leading-tight" data-id="element-632">Innova Health</h1>
              <p className="text-xs text-slate-400" data-id="element-633">Branch: Riyadh Central</p>
            </div>}
        </div>

        <nav className="flex-1 py-6 px-3 space-y-2" data-id="element-634">
          {navItems.map(item => <button key={item.id} onClick={() => onTabChange(item.id)} className={cn('w-full flex items-center gap-3 px-3 py-3 rounded-xl transition-colors', activeTab === item.id ? 'bg-blue-600 text-white' : 'text-slate-400 hover:bg-slate-800 hover:text-white')} data-id="element-635">
              <item.icon className="w-6 h-6 shrink-0" data-id="element-636" />
              {isSidebarOpen && <span className="font-medium" data-id="element-637">{item.label}</span>}
            </button>)}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden" data-id="element-638">
        {/* Top Header */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-8 shrink-0" data-id="element-639">
          <div className="flex items-center gap-4 flex-1 max-w-xl" data-id="element-640">
            <div className="relative w-full" data-id="element-641">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-642" />
              <input type="text" placeholder="Search orders, customers, or items..." className="w-full pl-10 pr-4 py-2 bg-slate-100 border-transparent focus:bg-white focus:border-blue-500 focus:ring-2 focus:ring-blue-200 rounded-lg text-sm transition-all outline-none" data-id="element-643" />
            </div>
          </div>
        </header>

        {/* Page Area */}
        <div className="flex-1 overflow-auto p-8" data-id="element-644">{children}</div>
      </main>
    </div>;
}